import React from "react";

function NFTGamingHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  NFT Gaming Platform Development
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Xeer Technology offers customized NFT Gaming Platform
                    Development services that blend the thrill of gaming with
                    the innovative potential of non-fungible tokens (NFTs). Our
                    goal is to empower game developers and studios to create
                    engaging, immersive experiences that revolutionize how
                    players interact with their in-game assets.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NFTGamingHero;
